import React, { memo } from 'react';
import cn from 'classnames';
import KeyboardKey from './KeyboardKey';

/**
 * A single row of keyboard keys.
 *
 * Memo-wrapped so it only re-renders when its own props change.
 * Receives only explicit named props — never the full `props` object —
 * so React.memo's shallow comparison works correctly.
 */
const KeyboardRow = memo(({
  rowString,
  rowIndex,
  type,
  screenType,
  btnSize,
  isCounter,
  isDriveThru,
  isCallCenter,
  layout,
  allLayouts,
  handleClick,
  display,
  handleLongPress,
  hideDomainNames,
  serverAppTheme,
  buttonTheme,
  tableKeyHeight,
  keyboardHeight,
  isDiscount,
  employeeCheck,
  spacebtn,
  donebuttontheme,
  orderSearch,
  customizeKeyBoard,
}) => {
  const keys = rowString.split(' ');

  const rowClass = cn(
    type === 'number' || type === 'numericAlpha' || type === 'numeric' || type === 'swipe'
      ? 'col-12'
      : screenType === 'couponPopUp'
      ? rowIndex === 0
        ? 'col h-25 py-1'
        : 'col h-25 pb-1'
      : 'col',
    type === 'textWithNumericEmail' && rowIndex === 2 && 'px-4',
    type === 'textWithoutNumeric'
      ? rowIndex === 1
        ? ''
        : 'col-12'
      : '',
    `d-flex ${
      (type === 'textWithoutNumeric' || orderSearch) && rowIndex === 1 ? '' : 'px-0'
    }`,
    customizeKeyBoard,
  );

  const rowStyle =
    (type === 'textWithoutNumeric' || orderSearch) && rowIndex === 1
      ? { padding: '0 2.4rem' }
      : undefined;

  return (
    <div className={rowClass} style={rowStyle}>
      {keys.map((keyToken, keyIndex) => (
        <KeyboardKey
          key={keyToken}
          keyToken={keyToken}
          rowIndex={rowIndex}
          keyIndex={keyIndex}
          type={type}
          screenType={screenType}
          btnSize={btnSize}
          isCounter={isCounter}
          isDriveThru={isDriveThru}
          isCallCenter={isCallCenter}
          layout={layout}
          allLayouts={allLayouts}
          handleClick={handleClick}
          display={display}
          handleLongPress={handleLongPress}
          hideDomainNames={hideDomainNames}
          serverAppTheme={serverAppTheme}
          buttonTheme={buttonTheme}
          tableKeyHeight={tableKeyHeight}
          keyboardHeight={keyboardHeight}
          isDiscount={isDiscount}
          employeeCheck={employeeCheck}
          spacebtn={spacebtn}
          donebuttontheme={donebuttontheme}
          orderSearch={orderSearch}
        />
      ))}
    </div>
  );
});

KeyboardRow.displayName = 'KeyboardRow';

export default KeyboardRow;
